import { createResource, RouterContext } from 'react-resource-router';

import workspaceUrls from 'src/sections/workspace/urls';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

const defaultPage = 1;

export type UserWorkspacesData = {
  pagelen: number;
  size: number;
  page: number;
  values: WorkspaceAccessObject[];
};

export type WorkspaceBase = {
  uuid: string;
  slug: string;
  type: string;
  links: {
    avatar: { href: string };
    self: { href: string };
  };
};

export type WorkspaceAccessObject = {
  administrator: boolean;
  type: string;
  workspace: WorkspaceBase;
};

export const userWorkspacesResource = createResource({
  type: 'USER_WORKSPACES',
  getKey: ({ query }: RouterContext) =>
    `user-workspaces:${query?.page || defaultPage}`,
  maxAge: 60 * 1000,
  getData: async ({ query }): Promise<UserWorkspacesData> => {
    const page = Number(query?.page) || defaultPage;
    const response = await fetch(
      authRequest(workspaceUrls.api.internal.userWorkspaces(page), {
        headers: jsonHeaders,
      })
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching workspaces (${response.status}): ${response.statusText}`
      );
    }

    const userWorkspaces: UserWorkspacesData = await response.json();

    return userWorkspaces;
  },
});
